module.exports = __webpack_public_path__ + "img/5cc094c.jpg";